<template>
  <div id="knowledgeBaseStep2Page"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="پایگاه دانش"></ActionBar>
    <div class="knowledge-base-header p-2 d-flex justify-space-between">
      <div class="knowledge-base-title  white--text font16px mr-6">{{ title }}</div>
    </div>
    <div v-if="!hasData" class="row mx-2 mt-10 knowledge-base-body">
      <div class="col-12">
        <v-alert
            border="bottom"
            class="mt-4 text-center"
            color="primary"
            dark>
      دسته بندی وجود ندارد
        </v-alert>
      </div>
    </div>
    <div v-else class="row container mx-auto p-0  mt-2 knowledge-base-body">
      <div v-for="item in items" :key="item.KnowledgeSubCategoryID" class="col-12 col-sm-6 col-lg-4 ">
        <div class="card-shadow round10px bg-white p-2 my-2 cursor-pointer" @click="goToKnowledgeBaseStep3(item.KnowledgeCategoryID,item.KnowledgeSubCategoryID,item.Name)">
          <div class="card-min-height-knowledge">
          <v-img v-if="item.FileUrl !== null" :src="$replaceHttps(item.FileUrl)" class="round10px" height="280"></v-img>
          </div>
          <div class="text-center mt-3">{{ item.Name }}</div>
        </div>
      </div>
    </div>
    <FooterMenu :currentPage="'knowledgeBase'"/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "KnowledgeBaseStep2",
  metaInfo: {
    title: 'مسیربرتر-پایگاه دانش'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    src: null,
    title: null,
    items: [],
    showLoaderDialog:false,
    hasData:true
  }),
  mounted() {
    _this = this;
    this.showLoaderDialog= true
    this.title = _this.$route.query.title
    this.getData()
  },
  methods: {
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "KnowledgeManagement/ListKnowledgeSubCategory?KnowledgeCategoryID=" + _this.$route.query.KnowledgeCategoryID, requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog= false
            let json = JSON.parse(result);
          let active = json.filter( x=> x.IsActive === true)
            if(active.length === 0){
              _this.hasData = false
            }else {
              _this.items = active
            }
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    goToKnowledgeBaseStep3(id,subId,name) {
      this.$router.push({path: 'KnowledgeBaseStep3', query: {KnowledgeCategoryID: id,KnowledgeSubCategoryID:subId,title:name}})

    }
  }
}
</script>

<style scoped>

</style>